import {
    App, InputNumber, Row, Typography, Form, Skeleton, Button
} from 'antd';
import { useTranslation } from "react-i18next";
import { getLastOdo, submitOdo } from "../../api/vehicle";
import { imageLocations } from "../image/ImageLocations";
import PanelFrameWithImage from "./PanelFrameWithImage";
import React, { useState, useEffect } from "react";
import {showApiError} from "../../utility/error/error-handler";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";

const { Text} = Typography;

const CaptureOdoPanel = ({vehicle, backgroundType, refreshPage, setRefreshPage}) => {

  const [lastOdo, setLastOdo] = useState(null);
  const { t } = useTranslation();
  const { isOnline } = useOnlineStatus();
  const { message, notification } = App.useApp();
  const [loadingProgress, setLoadingProgress] = useState(0);  //start 0 - button shows loading if less than 100
  const [submitProgress, setSubmitProgress] = useState(100);  //start 100 - button shows loading if less than 100
  const [isFormValid, setIsFormValid] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
      if (vehicle)
      {
          getLastOdo(vehicle.vehicleId, setLoadingProgress)
              .then(res => {
                  form.resetFields();
                  setLastOdo(res);
              },)
              .catch(err => {
                  // Show error if online otherwise show dash if offline (not been on this vehicle or cache not working)
                  if(isOnline) {
                      showApiError(t('title.submit_odo_reading'), err, notification);
                  } else {
                      setLastOdo({ reading: '-', readingDate: '-', unit: '', notAvail: true });  //special not available obj
                      setLoadingProgress(100);
                  }
              });
      }
      setRefreshPage(false);
    }, [t, notification, vehicle, form, refreshPage, setRefreshPage, isOnline]);

    // Form submitted not ok (fields NOT valid)
    const onFinishFailed = () => {
        setIsFormValid(false);
    }

    // Form submitted ok (fields valid)
    const onFinish = (values) => {
        if (!isFormValid) {
            setIsFormValid(true);  //change to confirm
            setTimeout(() => { setIsFormValid(false) }, 4000);
        } else {
            setIsFormValid(false);
            // Submit
            submitOdo(vehicle.vehicleId, values.newOdo, setSubmitProgress)
                .then(res => {
                    if (!res.validationError) {
                        message.success(t('message.successfully_submitted', {0: t('field.odo_reading')}));
                        form.resetFields();
                    }
                    setRefreshPage(true);
                })
                .catch(err => {
                    setSubmitProgress(100);
                    showApiError(t('title.submit_odo_reading'), err, notification)
                });
        }
    }
  
    const Buttons = () => {
      return (
        isOnline
        ?  (
            isFormValid
            ? <Button className="dp-confirm-button-waiting" type="primary" htmlType="submit" isFormSubmit={true} loading={submitProgress < 100 || (loadingProgress < 100 && !lastOdo)}>{t('action.confirm')}</Button>
            : <Button type="primary" htmlType="submit" isFormSubmit={true} loading={submitProgress < 100 || (loadingProgress < 100 && !lastOdo)}>{t('action.submit')}</Button>
           )
        :  <></>
      );
    }

    // Odo field for home panel (slightly different from more generic OdoReadingField)
    const HomeOdoReadingField = () => {
      return (
        isOnline
        ? // Odometer Field - not using generic OdoReadingField component as slightly different integrations here
        <Form.Item
          name="newOdo"
          help={lastOdo.validationError}
          type="number"
          rules={[
            { required: true, message: t('error.no_value_named', {0: t('field.odo_reading')})},
            () => ({
              validator(_, value) {
              if (!value && value !== 0) {
                 return Promise.reject();
              }
              if (isNaN(value)) {
                  return Promise.reject();
              }
              if (value < lastOdo.reading) {
                  return Promise.reject(t('error.minimum_value', {0: t('field.odo_reading'), 1: lastOdo.reading}));
              }
              return Promise.resolve();
              },
            }),
           ]}
          >
           <InputNumber
               style={{width: '200px'}}
               label={t('field.odo_reading')}
               changeOnBlur={true}
               controls={false}
               type="number"
               addonAfter={lastOdo.unit}
               status={lastOdo.validationError ? 'error' : ''}
               placeholder={t('action.enter_value')}
               pattern="[0-9]*"
               inputMode="numeric"
               max={9999999} />
        </Form.Item>
        :
        <></> );
    }

  return (
    <Form form={form} name="submit-odo" onFinish={onFinish} onFinishFailed={onFinishFailed}>
        <PanelFrameWithImage title={t('title.submit_odo_reading')}
                            imageLocation={imageLocations.ODOMETER_IMAGE}
                            backgroundType={backgroundType} height="260px"
                            buttons={<Buttons />}>
            {lastOdo  //basing on just main object and not having 'loadingProgress === 100' as jumpy at end of load when goes to 0
              ? // Show/Submit Odo
                <div>
                    <Row><Text>{t('field.last_recorded_odo', {0: lastOdo.reading, 1: lastOdo.unit, 2: ''})}<span style={{ textWrap: 'nowrap' }}>{lastOdo.readingDate}</span></Text></Row>
                    { lastOdo.notAvail
                      ? <></>
                      : <div>
                            <Row><Text>&nbsp;</Text></Row>
                            <Row><HomeOdoReadingField/></Row>
                        </div> }
                </div>
              : // Loading
                <div>
                    <Skeleton active title={false} paragraph={{ rows: 4 }} />
                </div>}
       </PanelFrameWithImage>
    </Form>
  );
}

export default CaptureOdoPanel;